import type { Locale } from "./types";

/**
 * The BCP 47 tag to hand `Intl` and `toLocale*String` for an app locale, so
 * every surface formats dates the same way rather than each picking its own
 * French.
 *
 * French maps to fr-CA: our French users are Canadian (Tom, 2026-10-07).
 */
export function intlLocale(locale: Locale): "en-US" | "fr-CA" {
  return locale === "fr" ? "fr-CA" : "en-US";
}
